import { useState, useEffect } from 'react';
import './ViaNegativa.css';

const ENABLED = false;
const FORM_ACTION = 'https://formspree.io/f/xwvgjjke';

export default function ViaNegativa() {
  const [modalOpen, setModalOpen] = useState(false);
  const [overlayActive, setOverlayActive] = useState(false);
  const [contentVisible, setContentVisible] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [emailValue, setEmailValue] = useState('');

  useEffect(function () {
    if (modalOpen) {
      const overlayTimer = setTimeout(function () {
        setOverlayActive(true);
      }, 10);
      const contentTimer = setTimeout(function () {
        setContentVisible(true);
      }, 320);
      return function () {
        clearTimeout(overlayTimer);
        clearTimeout(contentTimer);
      };
    }
  }, [modalOpen]);

  function closeModal() {
    setContentVisible(false);
    setOverlayActive(false);
    setTimeout(function () {
      setModalOpen(false);
      setSubmitted(false);
      setEmailValue('');
    }, 700);
  }

  function openModal() {
    setModalOpen(true);
  }

  function stopClick(e) {
    e.stopPropagation();
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!emailValue) return;

    fetch(FORM_ACTION, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: emailValue }),
    });

    setSubmitted(true);

    setTimeout(function () {
      closeModal();
    }, 2200);
  }

  if (!ENABLED) {
    return null;
  }

  const overlayClass = 'via-negativa-overlay ' + (overlayActive ? 'via-negativa-overlay-active' : '');
  const modalClass = 'via-negativa-modal ' + (contentVisible ? 'via-negativa-modal-visible' : '');

  return (
    <div>
      <button className="via-negativa-tab" onClick={openModal}>
        Via Negativa
      </button>

      {modalOpen ? (
        <div className={overlayClass} onClick={closeModal}>
          <div className={modalClass} onClick={stopClick}>
            <button className="via-negativa-close" onClick={closeModal}>
              ×
            </button>

            {!submitted ? (
              <div>
                <p className="via-negativa-line">
  The brightest most breathless beauty lies only through <span className="via-negativa-emphasis">Via Negativa</span> - the steep path into the deepest dark. Come through here and I'll take you.
</p>
                <form className="via-negativa-form" onSubmit={handleSubmit}>
                  <input
                    type="email"
                    name="email"
                    placeholder="email address"
                    required
                    value={emailValue}
                    onChange={function (e) { setEmailValue(e.target.value); }}
                    className="via-negativa-input"
                  />
                  <button type="submit" className="via-negativa-submit">
                    enter
                  </button>
                </form>
              </div>
            ) : (
              <p className="via-negativa-received">received.</p>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
}